export default "__VITE_ASSET__6cAdip8k__"